// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"89":"50631eb5","568":"ee63fc97","736":"6ebab85e","808":"8b50f6ba"}[chunkId] + ".chunk.js";
};